import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocalStorageService } from 'angular-2-local-storage';
import { Headers, Http, Response } from '@angular/http';

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Component({
  selector: 'app-input-email-modal',
  templateUrl: './modal-input-email.component.html',
})
export class ModalInputEmailComponent {
  form: FormGroup;
  referer: string;
  private apiResults = '//api.ras.universarium.org/atomemail';
  private headers = new Headers({'Content-Type': 'application/json'});

  constructor(
      public activeModal: NgbActiveModal,
      private fb: FormBuilder,
      private storage: LocalStorageService,
      private router: Router,
      private http: Http
  ) {
    this.form = fb.group({
      'email' : [null, Validators.compose([Validators.required, Validators.email])],
      'name' : [null, Validators.compose([Validators.required, Validators.maxLength(100)])]
    });
    this.referer = this.storage.get('referer') ? <string>this.storage.get('referer') : '/modules/3/lecture/1';
  }

  addPost(post) {
    this.storage.set('email', post.email);
    this.storage.set('name', post.name);

    if (this.storage.get('result')) {
      const body = {
        results: this.storage.get('result'),
        email: this.storage.get('email'),
        name: this.storage.get('email')
      };

      this.http.post(this.apiResults, body, { headers: this.headers })
          .map((resp: Response) => resp.json())
          .catch((error: any) => { return Observable.throw(error); })
          .subscribe();
    }

    this.activeModal.close();
    this.router.navigateByUrl(this.referer);
  }
}



// WEBPACK FOOTER //
// /var/www/ras.universarium.org/www/src/app/modal-input-email/modal-input-email.component.ts